/* Stretch the kit/footer background over both sections like the mock (background-size: 100% <combined height>). */
(() => {
  function apply() {
    const ft = document.querySelector('.sm-ft');
    if (!ft) return;
    const kit = document.querySelector('.sm-kit');
    const fh = ft.getBoundingClientRect().height;
    let total;
    if (kit) {
      const kr = kit.getBoundingClientRect(), fr = ft.getBoundingClientRect();
      const adjacent = Math.abs(fr.top - kr.bottom) < 2;
      total = adjacent ? kr.height + fh : fh * 2;
      if (!adjacent) kit.style.setProperty('--sm-kf-total', (kr.height * 2) + 'px');
      else kit.style.removeProperty('--sm-kf-total');
    } else {
      total = fh * 2;
    }
    document.documentElement.style.setProperty('--sm-kf-total', Math.round(total) + 'px');
    document.documentElement.style.setProperty('--sm-kf-ft', Math.round(fh) + 'px'); // tablet/desktop background alignment (sm-responsive.css)
  }
  const run = () => { apply(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', apply);
  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(apply, 120); }, { passive: true });
  if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => apply()); const go = () => document.querySelectorAll('.sm-kit,.sm-ft').forEach((e) => ro.observe(e)); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go(); }
  document.addEventListener('shopify:section:load', run);
})();
